import React from "react";
import { PropTypes } from "prop-types";
import { observer } from "mobx-react";
import { MrbTable } from "mrb/components/table";
import { MrbButton } from "mrb/components/button";
import { TableNoDataOverlay } from "common/components";
import { AddBetaChannelUser } from "administration/app-release/components";

function BetaChannelRowActions({ actions, item, t }) {
    return (
        <button
            type="button"
            className="c-btn c-btn--sml c-btn--ghost"
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                actions.remove.onClick(item);
            }}
        >
            {t(actions.remove.label)}
        </button>
    );
}

function BetaChannelTemplate({ betaChannelViewStore, t }) {
    const { gridStore, addUserModal } = betaChannelViewStore;

    return (
        <React.Fragment>
            <div className="u-display--flex u-display--flex--ai--center u-display--flex--jc--space-between u-mar--bottom--sml">
                <p className="u-type--sml">{t("ADMINISTRATION.APP_RELEASE.BETA_CHANNEL.DESCRIPTION")}</p>
                <MrbButton
                    t={t}
                    label="ADMINISTRATION.APP_RELEASE.BETA_CHANNEL.ADD_USER"
                    onClick={betaChannelViewStore.openAddUserModal}
                />
            </div>
            <MrbTable
                t={t}
                tableStore={gridStore}
                className="ag-theme-alpine u-mar--bottom--sml"
                emptyStateRender={TableNoDataOverlay}
                ActionsComponent={BetaChannelRowActions}
            />
            <AddBetaChannelUser betaChannelViewStore={betaChannelViewStore} modalParams={addUserModal} t={t} />
        </React.Fragment>
    );
}

BetaChannelTemplate.propTypes = {
    betaChannelViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default observer(BetaChannelTemplate);
